"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _bwaDeliveryPill = require("../../apis/bwa/widgets/bwa-delivery-pill");
var _constants = require("../../constants/constants");
var _utils = require("../../utils/utils");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BwADeliveryPillRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function BwADeliveryPillRenderHandler() {
    var _this;
    (0, _classCallCheck2["default"])(this, BwADeliveryPillRenderHandler);
    _this = _callSuper(this, BwADeliveryPillRenderHandler);
    _this.deliveryPillCount = 0;
    _this.maxRetries = 60;
    _this.retryIntervalMs = 300;
    _this.retryCount = 0;
    _this.emitIntervalId = null;
    _this.receivedIframeMessages = new Set();
    _this.pre.push(function () {
      _this.config = window.bwaMerchantConfig.bwaDeliveryPill;
      _this.bwaDeliveryPillContainers = _this.config.bwaDeliveryPillContainers;
    });
    return _this;
  }
  (0, _inherits2["default"])(BwADeliveryPillRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(BwADeliveryPillRenderHandler, [{
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.render();
            case 2:
              this.setupEventListeners();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.clearBwADeliveryPills();
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "injectBwADeliveryPill",
    value: function injectBwADeliveryPill(variantId) {
      var _this2 = this;
      this.bwaDeliveryPillContainers.forEach(function (_ref) {
        var id = _ref.id,
          iframeCSSClass = _ref.iframeCSSClass,
          iframeId = _ref.iframeId;
        var container = (0, _utils.safeGetElementById)(id(variantId));
        if (container) {
          container.appendChild((0, _bwaDeliveryPill.bwaDeliveryPillWidget)(iframeId(variantId), iframeCSSClass));
          _this2.deliveryPillCount++;
        }
      });
    }
  }, {
    key: "injectBwADeliveryPills",
    value: function injectBwADeliveryPills(cartItems) {
      var _this3 = this;
      if (Array.isArray(this.bwaDeliveryPillContainers) && this.bwaDeliveryPillContainers.length > 0) {
        this.bwaDeliveryPillContainers.forEach(function (bwaDeliveryPillContainer) {
          var containers = (0, _utils.safeQuerySelectorAll)(bwaDeliveryPillContainer.selectors);
          if (containers && containers.length > 0) {
            containers.forEach(function (container) {
              var variantId = bwaDeliveryPillContainer.getVariantId(container);
              if (variantId) {
                var cell = document.createElement(bwaDeliveryPillContainer.type);
                cell.id = bwaDeliveryPillContainer.id(variantId);
                cell.classList.add(bwaDeliveryPillContainer.containerCSSClass);
                container.appendChild(cell);
              }
            });
          } else {
            console.log("[BwA] Cart drawer container not found.");
          }
        });
      }
      var skuAvailabilityData = sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.SKU_AVAILABILITY_DATA);
      if (!skuAvailabilityData) return;
      var _JSON$parse = JSON.parse(skuAvailabilityData),
        skuAvailabilityList = _JSON$parse.skuAvailabilityList;
      if (!skuAvailabilityList) return;
      cartItems.forEach(function (item) {
        var _item$properties, _skuAvailabilityList$;
        var variantId = item.variant_id;
        var isBwASku = ((_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties._isBwASku) === _constants.SESSION_STORAGE_VALUES.TRUE || ((_skuAvailabilityList$ = skuAvailabilityList[variantId]) === null || _skuAvailabilityList$ === void 0 ? void 0 : _skuAvailabilityList$.isBuyable);
        if (isBwASku) {
          _this3.injectBwADeliveryPill(variantId);
        }
      });
    }
  }, {
    key: "clearBwADeliveryPills",
    value: function clearBwADeliveryPills() {
      this.bwaDeliveryPillContainers.forEach(function (_ref2) {
        var containerCSSClass = _ref2.containerCSSClass;
        var bwaDeliveryPills = (0, _utils.safeQuerySelectorAll)("." + containerCSSClass);
        if (bwaDeliveryPills) {
          bwaDeliveryPills.forEach(function (bwaDeliveryPill) {
            bwaDeliveryPill.remove();
          });
        }
      });
    }
  }, {
    key: "updateDeliveryPill",
    value: function updateDeliveryPill() {
      var _this4 = this;
      var skuAvailabilityData = sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.SKU_AVAILABILITY_DATA);
      if (!skuAvailabilityData) return;
      var _JSON$parse2 = JSON.parse(skuAvailabilityData),
        skuAvailabilityList = _JSON$parse2.skuAvailabilityList;
      if (!skuAvailabilityList) return;
      Object.keys(skuAvailabilityList).forEach(function (variantId) {
        var item = skuAvailabilityList[variantId];
        var message = {
          ecp: _constants.ECP,
          ecpSkuId: variantId,
          updateDeliveryPill: true,
          isInStock: item.inStock,
          deliveryPromise: item.latestArrivalDate
        };
        _this4.bwaDeliveryPillContainers.forEach(function (_ref3) {
          var id = _ref3.id,
            iframeId = _ref3.iframeId;
          var iframe = (0, _utils.safeGetElementById)(iframeId(variantId));
          if (iframe !== null && iframe !== void 0 && iframe.contentWindow) {
            iframe.contentWindow.postMessage(message, "*");
          }
        });
      });
    }
  }, {
    key: "retryUpdateDeliveryPill",
    value: function retryUpdateDeliveryPill() {
      this.retryCount++;
      if (this.retryCount <= this.maxRetries) {
        this.updateDeliveryPill();
      } else {
        clearInterval(this.emitIntervalId);
        this.emitIntervalId = null;
      }
    }
  }, {
    key: "setupRetryUpdateDeliveryPill",
    value: function setupRetryUpdateDeliveryPill() {
      var _this5 = this;
      if (this.emitIntervalId) clearInterval(this.emitIntervalId);
      this.retryCount = 0;
      this.emitIntervalId = setInterval(function () {
        return _this5.retryUpdateDeliveryPill();
      }, this.retryIntervalMs);
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this6 = this;
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.UPDATE_DELIVERY_PILL, function () {
        return _this6.updateDeliveryPill();
      });
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.SETUP_RETRY_UPDATE_DELIVERY_PILL, function (event) {
        var cartItems = event.detail.cartItems;
        _this6.clearBwADeliveryPills();
        _this6.injectBwADeliveryPills(cartItems);
        _this6.setupRetryUpdateDeliveryPill();
      });
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_CLEAR_DELIVERY_PILLS, function () {
        return _this6.clearBwADeliveryPills();
      });
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.CART_UPDATED, /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this6.render();
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })));
      window.addEventListener(_constants.EVENT_TYPE.MESSAGE, /*#__PURE__*/function () {
        var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(event) {
          return _regenerator["default"].wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (event.data.type === _constants.EVENT_TYPE.CUSTOM.BWA_DELIVERY_PILL_IFRAME_READY && _this6.emitIntervalId) {
                  _this6.receivedIframeMessages.add(event.data.ecpSkuId);
                  if (_this6.receivedIframeMessages.size === _this6.deliveryPillCount) {
                    clearInterval(_this6.emitIntervalId);
                    _this6.emitIntervalId = null;
                    _this6.deliveryPillCount = 0;
                    _this6.receivedIframeMessages.clear();
                  }
                }
              case 1:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=bwa-delivery-pill-render-handler.js.map
